import { render, staticRenderFns } from "./live-preview.vue?vue&type=template&id=1be7eb70"
import script from "./live-preview.vue?vue&type=script&lang=js"
export * from "./live-preview.vue?vue&type=script&lang=js"
import style0 from "./live-preview.vue?vue&type=style&index=0&id=1be7eb70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports